/* istanbul ignore file */
const styles = ({ spacing: { unit }, typography }) => ({
  root: {
    marginTop: unit * 3
  },
  title: {
    textTransform: 'uppercase',
    fontSize: unit * 2.5,
    fontFamily: typography.headline2.fontFamily
  },
  fields: {
    margin: [0, -(unit * 2)]
  },
  labelClass: {
    display: 'block'
  },
  row: {
    display: 'flex',
    marginBottom: unit * 2.5
  }
});

export default styles;
